import { Button, createStyles, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, makeStyles, Switch, TextField, Theme, Tooltip, Typography } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { ErrorAPI } from 'api/Associado/methods';
import { AxiosError } from 'axios';
import GenericModal, { IGenericModalProps } from 'components/GenericModal/GenericModal';
import { CircleCheckIcon, ColaboradorIcon, MaletaIcon, SyncIcon } from 'components/Icons';
import { RestricaoConta } from 'enuns/RestricaoConta';
import { AssembleiaContaAssessor } from 'models/AssembleiaContaAssessor';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useStore } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiasAssessorActionsLoadContas, assembleiasAssessorLoadEvento, assembleiasAssessorRegistrarPresenca } from 'store/modules/AssembleiasAssessorActions';
import { IAssembleiasAssessoresRegistrarPresenca, IAssembleiasAssessorReducer } from 'store/modules/AssembleiasAssessorReducer';
import { IAuthUserReducer } from 'store/modules/AuthReducer';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from 'store/modules/ModalsActionTypes';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';
import { contaDisponivelParaSelecao, contaSelecionadaPeloUsuario } from 'utils/AssembleiaAssessorUtils';
import { formatCPFOrCNPJ, clearFormat } from 'utils/cpfCnpjMask';
import { getToastError } from 'utils/ToasterUtils';
import { useContainerStyles, useHeadertyles, useItemStyles } from './style';

const MAX_CPF_CHARACTERS_COM_MASCARA = 14;
const MAX_CPF_CHARACTERS = 11;

export interface ISeletorContasParaVotoGenericProps extends IGenericModalProps {
  assembleia: IAssembleiasAssessorReducer,
  cpfCnpj: string,
  key: string,
}

export interface ISeletorContasParaVoto extends IModalProps {
  genericProps?: ISeletorContasParaVotoGenericProps,
  modalsActionsClose: (key: string) => ModalsActionsClose,
  assembleiasAssessorRegistrarPresenca: (registrarPresencaRequest: IAssembleiasAssessoresRegistrarPresenca, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => void,
  assembleiasAssessorLoadEvento: Function,
  assembleiasAssessorActionsLoadContas: (eventoId: number, cpfCnpj: string, callbackSuccess?: (contas: AssembleiaContaAssessor[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => void,
  usuario: IAuthUserReducer | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      maxHeight: '70vh',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    footerRight: {
      textAlign: 'right'
    },
    hidden: {
      display: 'none',
    },
    textField: {
      width: '100%',
      marginBottom: '10px'
    },
    nameAssessor: {
      fontSize: '16px',
      margin: 10,
      fontFamily: 'Nunito',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      }
    },
    legendas: {
      fontSize: '16px',
      margin: 10,
      fontFamily: 'Nunito',
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      }
    },
  }),
);

const mapStateToProps = (state:IReducer) => {
  return {
    assembleias: state.assembleiasAssessor,
    leftMenu: state.leftMenu,
    usuario: state.auth.usuario,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  modalsActionsClose,
  assembleiasAssessorRegistrarPresenca,
  assembleiasAssessorActionsLoadContas,
  assembleiasAssessorLoadEvento
}, dispatch);

const SeletorAssessorContasParaVotoModal = ({ assembleiasAssessorLoadEvento, assembleiasAssessorRegistrarPresenca, genericProps, modalsActionsClose, assembleiasAssessorActionsLoadContas, usuario }: ISeletorContasParaVoto) => {
  const [salvando, setSalvando] = useState(false);
  const classes = useStyles();
  const itemClasses = useItemStyles();
  const containerClasses = useContainerStyles();
  const headerClasses = useHeadertyles();
  const { t } = useTranslation();
  const [cpf, setCpf] = useState('');
  const [buscando, setBuscando] = useState(false)
  const [searched, setSearched] = useState(false)
  const [idConvocados, setIdConvocados] = useState<number[]>([]);
  const reducerState: IReducer = useStore().getState();

  const toClose = (): void => {
    if (genericProps && genericProps.key) {
      modalsActionsClose(genericProps.key);
    }
  }

  const getContas = (): AssembleiaContaAssessor[] => {
    if ( cpf === '' ) {
      return reducerState.assembleiasAssessor.contasDisponiveis = [];
    }
    if (reducerState.assembleiasAssessor && reducerState.assembleiasAssessor.contasDisponiveis) {
      return reducerState.assembleiasAssessor.contasDisponiveis;
    }
    return [];
  }

  const contaSelecionada = (conta: AssembleiaContaAssessor): boolean => {
    if (genericProps && genericProps.cpfCnpj) {
      return idConvocados.indexOf(conta.idConvocado) > -1 ? true : false || contaSelecionadaPeloUsuario(conta, genericProps.cpfCnpj);
    }
    return false;
  }

  const handleSelecionarConta = (conta: AssembleiaContaAssessor) => {
    let idConvocadosCopy: number[] = [ ...idConvocados ];
    const idConvocadoFoundIndex: number = idConvocadosCopy.indexOf(conta.idConvocado);
    if (idConvocadoFoundIndex > -1) {
      idConvocadosCopy.splice(idConvocadoFoundIndex, 1);
    } else {
      idConvocadosCopy.push(conta.idConvocado);
    }
    setIdConvocados(idConvocadosCopy);
  }

  const salvarPresencas = () => {

    let request: IAssembleiasAssessoresRegistrarPresenca = {
      convocacoes: idConvocados,
      cpf: cpf,
      idEvento: genericProps?.assembleia?.evento?.id
    }

    if (genericProps && genericProps.assembleia && genericProps.cpfCnpj) {
      setSalvando(true);
      assembleiasAssessorRegistrarPresenca(
        request,
        () => {
          setSalvando(false);
          assembleiasAssessorLoadEvento(genericProps?.assembleia.evento?.id);
          toClose();
        },
        () => {
          setSalvando(false);
        }
      );
    }
  }
  
  const contaElegivelParaSelecao = useCallback((conta: AssembleiaContaAssessor): boolean => {
    if (genericProps && genericProps.cpfCnpj) {
      return contaDisponivelParaSelecao(conta, genericProps.cpfCnpj);
    }
    return false;
  }, [genericProps]);

  const contaDisabled = (conta: AssembleiaContaAssessor): boolean => {
    return !contaElegivelParaSelecao(conta);
  }

  const temColaborador = useMemo<boolean>(() => {
    if (cpf.length === MAX_CPF_CHARACTERS && reducerState.assembleiasAssessor && reducerState.assembleiasAssessor.contasDisponiveis){
      return !!reducerState.assembleiasAssessor.contasDisponiveis.find(it => it.restricao === RestricaoConta.Colaborador);
    }
    return false;
  }, [cpf, reducerState])

  const temColaboradorPJ = useMemo<boolean>(() => {
    if (cpf.length === MAX_CPF_CHARACTERS && reducerState.assembleiasAssessor && reducerState.assembleiasAssessor.contasDisponiveis){
      return !!reducerState.assembleiasAssessor.contasDisponiveis.find(it => it.restricao === RestricaoConta.ColaboradorPJ);
    }
    return false;
  }, [cpf,reducerState])

  const temColaboradorMei = useMemo<boolean>(() => {
    if (cpf.length === MAX_CPF_CHARACTERS && reducerState.assembleiasAssessor && reducerState.assembleiasAssessor.contasDisponiveis){
      return !!reducerState.assembleiasAssessor.contasDisponiveis.find(it => it.restricao === RestricaoConta.ColaboradorMei);
    }
    return false;
  }, [cpf,reducerState])

  const buscaNomeRepresentante = (cpf: string): string | undefined => {
    if (reducerState.assembleiasAssessor && reducerState.assembleiasAssessor.contasDisponiveis) {
      let nomeRepresentante = reducerState.assembleiasAssessor.contasDisponiveis.filter(it => it.cpfRepresentante === cpf).find(it => it.cpfRepresentante === cpf)?.nomeRepresentante;

      if (nomeRepresentante === undefined || nomeRepresentante === '') {
        nomeRepresentante = reducerState.assembleiasAssessor.contasDisponiveis.filter(it => it.cpfCnpj === cpf).find(it => it.cpfCnpj === cpf)?.nome;
      }

      return nomeRepresentante;
    }
  }

  const confirmButtomIsDisabled = () => {
    return !getContas().find(it => !it.presente);
    // let result: boolean = false
    // getContas().forEach(it => result = it.presente)
    // getContas().find(it => it.)
    // return result;
  }
  useEffect(() => {
    if(cpf.length === MAX_CPF_CHARACTERS && genericProps && genericProps.assembleia && genericProps.assembleia.evento){
      assembleiasAssessorActionsLoadContas(genericProps.assembleia.evento.id, cpf, () => {}, error => getToastError( error.message ))
    }
    // eslint-disable-next-line
    }, [cpf]);

  useEffect(() => {
    if (buscando && reducerState.assembleiasAssessor && reducerState.assembleiasAssessor.contasDisponiveis) {
      let idConvocadosCopy: number[] = [
        ...idConvocados,
        ...reducerState.assembleiasAssessor.contasDisponiveis.filter(
          (conta: AssembleiaContaAssessor) => {
            // já está selecionado na modal
            if (idConvocados.indexOf(conta.idConvocado) > -1) {
              return false;
            }
            if ( genericProps && genericProps.cpfCnpj ) {
              if (contaDisponivelParaSelecao(conta, genericProps.cpfCnpj)) {
                return true;
              }
            }
            return false;
          }
        ).map((conta: AssembleiaContaAssessor): number => {
          return conta.idConvocado;
        })
      ];
      setIdConvocados(idConvocadosCopy);
      setBuscando(false);
    }
    // eslint-disable-next-line
  }, [genericProps?.assembleia, setBuscando, buscando, genericProps, genericProps?.cpfCnpj, setIdConvocados, contaElegivelParaSelecao, idConvocados]);

  return (
    <GenericModal
      title={ t("SelectorAssessorContasParaVotoModal.title")}
      content={(
        <List>
          <TextField 
            label={ t("SelectorAssessorContasParaVotoModal.textFieldPlaceHolder") }
            className={ classes.textField }
            value={formatCPFOrCNPJ(cpf, true)}
            onChange={e => setCpf(clearFormat(e.currentTarget.value, true))}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    onClick={ () => {
                      if ( cpf.length !== MAX_CPF_CHARACTERS ) {
                        getToastError( t("SelectorAssessorContasParaVotoModal.error") );
                        return null;
                      }

                      if( genericProps && genericProps.assembleia && genericProps.assembleia.evento ) {
                        setSearched(true)
                        assembleiasAssessorActionsLoadContas(genericProps.assembleia.evento.id, cpf, () => {}, error => getToastError( error.message ))
                      }
                    }}>
                    {reducerState.assembleiasAssessor.loadingContas ? <SyncIcon className="animation-rotate" /> : <SearchIcon/>}
                  </Button>
                </InputAdornment>
              ),
            }}
            inputProps={{
              maxLength: MAX_CPF_CHARACTERS_COM_MASCARA
            }}
          helperText={ t("SelectorAssessorContasParaVotoModal.helperText") }
            />
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.nameAssessor}>
              <b>{ buscaNomeRepresentante(cpf) }</b>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.legendas}>
              {temColaborador && (
                <Typography className={headerClasses.legendaText} component="p">
                  <ColaboradorIcon className={headerClasses.legendaIcon} />
                  {t(`canalVoz.legendaColaborador`)}
                </Typography>
              )}
              {temColaboradorPJ && (
                <Typography className={headerClasses.legendaText} component="p">
                  <MaletaIcon className={headerClasses.legendaIcon} />
                  {t(`canalVoz.legendaColaboradorPJ`)}
                </Typography>
              )}
              {temColaboradorMei && (
                <Typography className={headerClasses.legendaText} component="p">
                  <MaletaIcon className={headerClasses.legendaIcon} />
                  {t(`canalVoz.legendaColaboradorMei`)}
                </Typography>
              )}
            </Grid>
          </Grid>
          {/*
          <ListItem className={headerClasses.root}>
            <Grid container>
              <Grid item xs={6} sm={2} md={2} lg={2} className={headerClasses.text}>
                { t("SeletorContasParaVotoModal.headerTextConta") }
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} className={headerClasses.text}>
              { t("SeletorContasParaVotoModal.headerTextNomAsso") }
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} className={headerClasses.textPresença}>
              { t("SeletorContasParaVotoModal.headerTextPresen") }
              </Grid>
            </Grid>
          </ListItem> */}
          { buscaNomeRepresentante(cpf) &&
            getContas().length > 0 ?
            getContas().map((conta: AssembleiaContaAssessor, index: number) => {
              return (
                <Tooltip title={ `${ conta.numeroConta }⠀⠀ ${ conta.nome }` } key={ index } arrow>
                  <ListItem
                    // button={ conta ? !conta.presente : false }
                    classes={containerClasses}
                    disabled={ contaDisabled(conta) }
                    onClick={() => handleSelecionarConta(conta)}
                  >
                    <ListItemText
                      primary={(
                        <Grid container>
                          { conta.nome &&
                            (
                              <Grid item xs={12} className={headerClasses.switchAceiteRow}>
                                <Typography className={headerClasses.legendaText} component="p">
                                  {conta.restricao === RestricaoConta.Colaborador && (
                                    <Tooltip title={t(`canalVoz.legendaColaborador`).toString()}>
                                      <ColaboradorIcon className={headerClasses.tableIcon} />
                                    </Tooltip>
                                  )}
                                  {conta.restricao === RestricaoConta.ColaboradorPJ && (
                                    <Tooltip title={t(`canalVoz.legendaColaboradorPJ`).toString()}>
                                      <MaletaIcon className={headerClasses.tableIcon} />
                                    </Tooltip>
                                  )}
                                  {conta.restricao === RestricaoConta.ColaboradorMei && (
                                    <Tooltip title={t(`canalVoz.legendaColaboradorMei`).toString()}>
                                      <MaletaIcon className={headerClasses.tableIcon} />
                                    </Tooltip>
                                  )}
                                  { conta.nome }
                                </Typography>
                              </Grid>
                            )
                          }
                          <Grid item xs={12} >
                            {t("SelectorAssessorContasParaVotoModal.infos", {
                              codigoCooperativa: conta.codigoCooperativa,
                              codigoAgencia: conta.codigoAgencia,
                              numeroConta: conta.numeroConta
                            })}
                          </Grid>
                        </Grid>
                      )}
                      primaryTypographyProps={{
                        component: 'span',
                      }}
                      secondary={
                        !conta.origem ?
                          !conta.presente ?
                            t("SelectorAssessorContasParaVotoModal.presenca.confirmarCanalVoz") :
                            t("SelectorAssessorContasParaVotoModal.presenca.confirmadoDigital")
                        :
                        t("SelectorAssessorContasParaVotoModal.presenca.canalVoz")
                      }
                      secondaryTypographyProps={{
                        component: 'span',
                      }}
                      classes={itemClasses}
                    />
                    <ListItemSecondaryAction>
                      {
                        conta.presente !== true ?
                        <Switch
                          color="primary"
                          checked={ contaSelecionada(conta) }
                          onChange={
                            (event: React.ChangeEvent<HTMLInputElement>) => {
                              handleSelecionarConta(conta)
                            }
                          }
                          name="gilad"
                          disabled={ salvando || contaDisabled(conta) } />
                        :
                        <CircleCheckIcon className={ itemClasses.circleChecked }/>
                      }
                    </ListItemSecondaryAction>
                  </ListItem>
                </Tooltip>
            )})
            :
            searched ?
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} className={headerClasses.noContent}>
                 { t("SelectorAssessorContasParaVotoModal.noContent") }
              </Grid>
            </Grid>
            : null
          }
        </List>
      )}
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
        footerContent: (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} className={ cpf.length === 0 ? classes.hidden : classes.footerRight }>
              <Button
                variant="contained"
                color="primary"
                onClick={ salvarPresencas }
                disabled={ salvando || idConvocados.length === 0 || confirmButtomIsDisabled() }
                startIcon={ <CircleCheckIcon /> }
                endIcon={salvando ? <SyncIcon className="animation-rotate" /> : null}
                >{ t("SeletorContasParaVotoModal.confirmLabel") }</Button>
            </Grid>
          </Grid>
        )
      }}
      />
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SeletorAssessorContasParaVotoModal);